/**
 * Autogenerated file.
 * For adding or changing icons, see README.MD
 */
import React from 'react';
import { createIcon } from '../../icon/create-icon'; // Outline

const LockOutline = props => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M8.62 9.375v-3.37c0-.9.36-1.76.99-2.39.64-.63 1.49-.99 2.39-.99s1.75.36 2.39.99c.63.63.99 1.49.99 2.39v3.37m-10.88 0h15c.41 0 .75.34.75.75v10.5c0 .41-.34.75-.75.75h-15c-.41 0-.75-.34-.75-.75v-10.5c0-.41.34-.75.75-.75z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M12 16.315a.939.939 0 1 0 0-1.88.939.939 0 1 0 0 1.88z"
})); // Fill


const LockFill = props => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M19.5 8.625h-3.38v-2.62c0-1.1-.43-2.15-1.2-2.92a4.125 4.125 0 0 0-5.84 0c-.77.77-1.2 1.82-1.2 2.92v2.62H4.5a1.499 1.499 0 0 0-1.5 1.5v10.5a1.499 1.499 0 0 0 1.5 1.5h15a1.499 1.499 0 0 0 1.5-1.5v-10.5a1.499 1.499 0 0 0-1.5-1.5zm-7.5 7.88c-.22 0-.44-.07-.63-.19-.18-.13-.32-.3-.41-.51-.08-.21-.11-.43-.06-.65.04-.22.15-.42.3-.58.16-.15.36-.26.58-.3.22-.05.44-.02.65.06.21.09.38.23.51.41.12.19.18.41.18.63 0 .3-.11.58-.32.8-.22.21-.5.33-.8.33zm2.62-7.88H9.38v-2.62c0-.7.27-1.37.76-1.86.5-.49 1.16-.77 1.86-.77s1.36.28 1.86.77c.49.49.76 1.16.76 1.86v2.62z"
})); // DuoTone


const LockDuotone = props => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M19.5 9.375h-15c-.41 0-.75.34-.75.75v10.5c0 .41.34.75.75.75h15c.41 0 .75-.34.75-.75v-10.5c0-.41-.34-.75-.75-.75z",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M8.62 9.375v-3.37c0-.9.36-1.76.99-2.39.64-.63 1.49-.99 2.39-.99s1.75.36 2.39.99c.63.63.99 1.49.99 2.39v3.37m-10.88 0h15c.41 0 .75.34.75.75v10.5c0 .41-.34.75-.75.75h-15c-.41 0-.75-.34-.75-.75v-10.5c0-.41.34-.75.75-.75z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M12 16.505c.62 0 1.12-.51 1.12-1.13s-.5-1.13-1.12-1.13-1.12.51-1.12 1.13.5 1.13 1.12 1.13z"
}));
/**
  Icon LockIcon in security group
*/


export const LockIcon = createIcon('LockIcon', 'lock', 'security', LockOutline, LockFill, LockDuotone, "0 0 24 24");